import React, { useEffect, useState } from 'react';

interface ImageWithFallbackProps {
  src?: string | null;
  alt: string;
  fallbackSrc?: string;
  className?: string;
  style?: React.CSSProperties;
  onError?: () => void;
  onLoad?: () => void;
}

const DEFAULT_FALLBACK_IMAGE = "https://blocks.astratic.com/img/general-img-landscape.png";

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  alt,
  fallbackSrc = DEFAULT_FALLBACK_IMAGE,
  className,
  style,
  onError,
  onLoad
}) => {
  const [imgSrc, setImgSrc] = useState<string>(fallbackSrc);

  useEffect(() => {
    if (src && src.trim() !== '') {
      const img = new Image();
      img.src = src;

      img.onload = () => {
        setImgSrc(src);
        onLoad?.();
      };

      img.onerror = () => {
        setImgSrc(fallbackSrc);
        onError?.();
      };
    } else {
      setImgSrc(fallbackSrc);
    }
  }, [src, fallbackSrc, onError, onLoad]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      style={style}
    />
  );
};

export default ImageWithFallback; 